export default __webpack_public_path__ + "static/media/city-solid.f50bc351.svg";